import { Suspense } from "react";
import Loader from "./loader";

export function SuspenseLoader({ children }: { children: React.ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="w-full h-full min-h-screen flex justify-center items-center">
          <Loader />
        </div>
      }
    >
      {children}
    </Suspense>
  );
} 